import { render, staticRenderFns } from "./OpeningAdvertisement.vue?vue&type=template&id=33c4a34e&scoped=true"
import script from "./OpeningAdvertisement.vue?vue&type=script&lang=js"
export * from "./OpeningAdvertisement.vue?vue&type=script&lang=js"
import style0 from "./OpeningAdvertisement.vue?vue&type=style&index=0&id=33c4a34e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c4a34e",
  null
  
)

export default component.exports